import { useEffect, useState, useCallback } from "react";
import { api } from "./api";

const STORAGE_KEY = "garden_sage_location_v1";

export function useLocation() {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  // Hydrate from localStorage first, then refresh from backend.
  useEffect(() => {
    const cached = localStorage.getItem(STORAGE_KEY);
    if (cached) {
      try { setLocation(JSON.parse(cached)); } catch (e) { /* ignore */ }
    }
    api.get("/location")
      .then((r) => {
        if (r.data && r.data.latitude) {
          setLocation(r.data);
          localStorage.setItem(STORAGE_KEY, JSON.stringify(r.data));
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = useCallback(async (loc) => {
    const r = await api.post("/location", loc);
    setLocation(r.data);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(r.data));
    return r.data;
  }, []);

  return { location, setLocation: save, loading };
}
